import styled from 'styled-components';
import { Input } from 'antd';
export const FONT_FAMILY = `'Inter', 'Segoe UI', Arial, sans-serif`;
export const PageWrapper = styled.div `
  padding: 48px 32px 32px 32px;
  font-family: ${FONT_FAMILY};
  background: #f6f8fa;
  min-height: 100vh;
  @media (max-width: 900px) {
    padding: 32px 10px 24px 10px;
  }
  @media (max-width: 600px) {
    padding: 12px 2vw 12px 2vw;
  }
`;
export const Title = styled.h1 `
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0;
  font-family: ${FONT_FAMILY};
  @media (max-width: 600px) {
    font-size: 18px;
  }
`;
export const TopBar = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
  flex-wrap: wrap;
  gap: 12px;
`;
export const Description = styled.div `
  margin-bottom: 32px;
  color: #444;
  font-size: 16px;
  line-height: 1.7;
  background: #fff;
  border-radius: 12px;
  padding: 22px 0 22px 0;
  box-shadow: 0 1px 4px rgba(60,60,60,0.03);
  font-family: ${FONT_FAMILY};
  @media (max-width: 900px) {
    font-size: 15px;
    padding: 16px 10px 16px 10px;
  }
  @media (max-width: 600px) {
    font-size: 14px;
    padding: 12px 4vw 12px 4vw;
  }
`;
export const ActionsWrapper = styled.div `
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const DeleteIconButton = styled.button `
  border: none;
  background: none !important;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #b0b0b0;
  font-size: 22px;
  transition: color 0.2s;
  &:hover {
    color: #ff4d4f;
    background: none !important;
  }
`;
export const TableWrapper = styled.div `
  width: 100%;
  overflow-x: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 4px rgba(60,60,60,0.03);
  padding: 0 0 8px 0;
  @media (max-width: 900px) {
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(60,60,60,0.04);
  }
  @media (max-width: 600px) {
    border-radius: 6px;
    padding: 0 0 4px 0;
    min-width: 340px;
  }
`;
export const SecretKeyWrapper = styled.span `
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
  min-width: 0;
  overflow: visible;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding-right: 8px;

  button {
    background: #fff;
    border-radius: 4px;
    padding: 2px 4px;
    margin-left: 2px;
    z-index: 1;
    transition: background 0.2s;
    &:hover {
      background: #f0f0f0;
    }
  }

  @media (max-width: 600px) {
    font-size: 13px;
    gap: 4px;
    padding-right: 2px;
    button {
      font-size: 16px;
      padding: 2px 2px;
    }
  }
`;
export const ModalLabel = styled.div `
  margin-bottom: 10px;
  font-weight: 600;
  font-size: 15px;
  color: #222;
  font-family: ${FONT_FAMILY};
  @media (max-width: 600px) {
    font-size: 14px;
  }
`;
export const StyledInput = styled(Input) `
  font-size: 15px;
  font-family: ${FONT_FAMILY};
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  @media (max-width: 600px) {
    font-size: 14px;
    padding: 6px 8px;
  }
`;
